import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { MonoCode } from '@lebinatikra/rtl-utils';
import type { GroupType } from '@lebinatikra/shared-types';

const GROUP_TYPES: GroupType[] = ['class', 'staff', 'cohort', 'custom'];

interface GroupFormValues {
  id: string;
  name: string;
  type: GroupType;
}

export function GroupEdit() {
  const { t } = useTranslation();
  const { organizationId } = useParams();
  const { formProps, saveButtonProps, query } = useForm<GroupFormValues>({
    resource: 'groups',
    action: 'edit',
    redirect: 'show',
    meta: { parentId: organizationId },
  });
  const id = query?.data?.data?.id;

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        {id ? (
          <Form.Item label={t('common.id')}>
            {/* rtl-utils:bidi-wrapped */}
            <MonoCode>{id}</MonoCode>
          </Form.Item>
        ) : null}
        <Form.Item name="name" label={t('common.name')} rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="type" label={t('fields.type')} rules={[{ required: true }]}>
          <Select options={GROUP_TYPES.map((g) => ({ value: g, label: g }))} />
        </Form.Item>
      </Form>
    </Edit>
  );
}
